// extracted by mini-css-extract-plugin
module.exports = {"divCentro":"Ficha_divCentro__2ozoy"};